import React from 'react';
import { VideoSlotGrid } from './VideoSlotGrid';
import { VideoControlBar } from './VideoControlBar';
import { VideoHistoryStrip } from './VideoHistoryStrip';
import { ScreenToastBar } from './ScreenToastBar';
import { ScreenFullView } from './ScreenFullView';
import { PromptEditorDrawer } from './PromptEditorDrawer';
import { useSlotScreenGeneratorStore } from '@store/slotScreenGeneratorStore';

export function VideoCompiler() {
  const promptDrawerScreenId = useSlotScreenGeneratorStore(s => s.promptDrawerScreenId);
  const promptDrawerField = useSlotScreenGeneratorStore(s => s.promptDrawerField);
  const closePromptDrawer = useSlotScreenGeneratorStore(s => s.closePromptDrawer);

  return (
    <div className="flex-1 flex flex-col overflow-hidden relative">
      {/* Horizontal card row */}
      <div className="flex-1 overflow-y-auto">
        <VideoSlotGrid />
      </div>

      {/* Scrollable video history */}
      <VideoHistoryStrip />

      {/* Fixed bottom: video controls */}
      <VideoControlBar />

      {/* Toast notifications */}
      <ScreenToastBar />

      {/* Overlays */}
      <ScreenFullView />
      <PromptEditorDrawer
        isOpen={promptDrawerScreenId !== null && promptDrawerField !== null}
        onClose={closePromptDrawer}
        screenId={promptDrawerScreenId!}
        field={promptDrawerField!}
      />
    </div>
  );
}
